import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { useThemeStore } from './stores/themeStore';

// Initialize theme
useThemeStore.getState().initTheme();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
